import { SVGProps } from "react";

export const BookIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={props.width || "18"}
        height={props.height || "15"}
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.5 2C2.5 1.44772 2.94772 1 3.5 1H15.5C16.0523 1 16.5 1.44772 16.5 2V14C16.5 14.5523 16.0523 15 15.5 15H3.5C2.94772 15 2.5 14.5523 2.5 14V2Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 2H5.5C4.94772 2 4.5 2.44772 4.5 3V14"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 4H13"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <path
            d="M7 6H13"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
        <path
            d="M7 8H10"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </svg>
);
